import React from "react";
import Project from "./Project";
import "../Styles/tailwind.output.css";
import { ReactComponent as ProjectsTitle } from "../Assets/projects-title.svg";

//importing project images in local
import Exammaterials from "../Assets/exammaterials.png"
import PersonalPortfolio from "../Assets/personalportfolio.png"

function Projects() {
  return (
    <div className="flex flex-col items-center">
      <div className="lg:pl-16 lg:pt-16 pl-4 pt-4">
        <ProjectsTitle className="lg:w-56 sm:w-40 w-32" />
      </div>
      <div className="grid lg:grid-cols-3 sm:grid-cols-2 gap-4 lg:p-16 p-4">
        {/* Search Itunes */}
        <Project
          title="Search itunes app"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/searchitunes-reactjs/master/interface.png"
          about="This project uses Apple's itunes API. Users can search any songs and preview 30 seconds of song with in the App."
          learned={[
            "Redux, React-Redux",
            "Styled Components",
            "Audio with javascript",
            "Dark mode switch",
          ]}
          githubLink="https://github.com/Royal-lobster/searchitunes-reactjs"
          projectLink="https://search-itunes.netlify.app/"
        />
        {/* JNTUV news app */}
        <Project
          title="JNTUK UCEV news app"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/jntuvnews-reactjs/master/screenshots.png"
          about="This tiny project is done because its a bit confusing to get the latest news from official website, because the Wordpress theme they use is a bit confusing. Hence i made this webpage which directly pulls the rss feed from the official website and display it in cleaner way with React."
          learned={[
            "Converting XML data to JSON",
            "Using CORS Proxy API",
            "Rendering HTML from string",
          ]}
          githubLink="https://github.com/Royal-lobster/jntuvnews-reactjs"
          projectLink="https://jntuk-ucev-news.web.app/"
        />

        {/* spotify clone */}
        <Project
          title="Spotify Clone"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/spotifyclone-reactjs/master/screenshot.png"
          about="This project is done to practice UI design of Spotify in React. This build uses the original spotify api. users can login to this application and see their playlist list inside this app and view all the tracks. This build uses react context to manage state."
          learned={[
            "React Context API",
            "Material icons",
            "UI designing with React",
          ]}
          githubLink="https://github.com/Royal-lobster/spotifyclone-reactjs"
          projectLink="https://royallobster-spotify-clone.web.app/"
        />
        {/* Personal Portfolio */}
        <Project
          title="Personal Portfolio Project"
          imgurl={PersonalPortfolio}
          about="My own personal portfolio project website to show case some of my Projects done in my free time"
          learned={[
            "Using React in only one section",
            "Changing Color Themes",
            "Designing new Concept",
          ]}
          githubLink="https://github.com/Royal-lobster/jntuvnews-reactjs"
          projectLink="https://jntuk-ucev-news.web.app/"
        />
        {/* twitter clone */}
        <Project
          title="Twitter Clone"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/twitterclone-reactjs/master/screenshot-twitterclone.png"
          about="This project is a clone of twitter. It is done to practice how to build UI like twitter. Users can post few tweets which are then stored and servered from firebase database i also made it to support image links."
          learned={["Firebase database", "Material icons", "Responsive desing"]}
          githubLink="https://github.com/Royal-lobster/twitterclone-reactjs"
          projectLink="https://royallobster-twitter-clone.web.app/"
        />
        {/* instagram clone */}
        <Project
          title="Instagram Clone"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/instagramclone-reactjs/master/screenshot.png"
          about="This project is a clone of Instagram created using Reactjs and firebase. It has complete user authentication with firebase. once logged in, You can post images and also comment to other posts."
          learned={[
            "Firebase database",
            "Firebase storage",
            "Firebase authentication",
            "Material UI",
            "Responsive design",
          ]}
          githubLink="https://github.com/Royal-lobster/instagramclone-reactjs"
          projectLink="https://royal-lobster-instagram-clone.web.app/"
        />
        {/* netflix clone */}
        <Project
          title="Netflix Clone"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/netflixclone-reactjs/master/screenshot.png"
          about="This project is a clone of Netflix created using Reactjs and firebase. It pulls data from TMDB and displays to the screen. You can press one of the movie or show to get the trailer which is searched and inserted from youtube."
          learned={["Api call Using Axios", "Firebase Hosting", "BEM CSS"]}
          githubLink="https://github.com/Royal-lobster/instagramclone-reactjs"
          projectLink="https://royal-lobster-netfilx-clone.web.app/"
        />
        {/* Todolist app */}
        <Project
          title="Todolist App (React Native)"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/todolistapp-reactnative/master/screenshot.png"
          about="A Simple Todo list app done to explore React Native"
          learned={[
            "using expo",
            "views",
            "Styling in React Native",
            "FlatList",
          ]}
          githubLink="https://github.com/Royal-lobster/todolistapp-reactnative"
        />
        {/* Currency converter */}
        <Project
          title="Currency converter"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/currencyconverter-reactjs/master/screenshotimg.png"
          about="A simple currency caluculator done to practice math with react and calling api"
          learned={[
            "Currency conversion with react",
            "Using currency API",
            "React hooks",
          ]}
          githubLink="https://github.com/Royal-lobster/currencyconverter-reactjs"
          projectLink="https://react-currencyconverter.netlify.app/"
        />
        {/* movie search */}
        <Project
          title="Movie Search"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/moviesearch-expressjs/master/screenshot.png"
          about="A small Movie search appilication build with Express js as backend and EJS as frontend"
          learned={["Express js", "EJS", "API call in backend"]}
          githubLink="https://github.com/Royal-lobster/moviesearch-expressjs/"
          projectLink="https://movieserch.herokuapp.com/search"
        />
        {/* excersise app */}
        <Project
          title="ExcerTracker App"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/exercisetrackerapp-mern/master/screenshot.png"
          about="This application is done using MERN Stack Technologies. Users can log their excersise details in to it which is then stored in mongodb atlas and showed to the user using react as frontend"
          learned={[
            "Express js",
            "MERN Stack devlopment",
            "Mongo DB Atlas",
            "Combining react with express",
            "building rest api",
          ]}
          githubLink="https://github.com/Royal-lobster/exercisetrackerapp-mern"
          projectLink="https://excertrack.herokuapp.com/"
        />
        {/* face app */}
        <Project
          title="FaceExpresion Detector"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/aifacerecognition-javascript/master/screenshot.png"
          about="This app is build with javascript with face api library"
          learned={[
            "Using face api",
            "canvas and rendering video",
            "Hosting with Netlify",
          ]}
          githubLink="https://github.com/Royal-lobster/aifacerecognition-javascript"
          projectLink="https://face-expression-detection.netlify.app/"
        />
        {/* xylophone app */}
        <Project
          title="Xylophone App"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/xylophoneapp-android/master/screenshot.png"
          about="This app is a simple andriod app build with Java. It has few sound tracks which plays when user press the buttons in the app. This app uses android soundpool api"
          learned={[
            "Using SoundPool api",
            "Playing sounds with an app",
            "few battles with gradle 😢",
          ]}
          githubLink="https://github.com/Royal-lobster/xylophoneapp-android"
        />
        {/* quiz app */}
        <Project
          title="Quiz App"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/quizapp-android/master/screenshot.png"
          about="This app is a simple andriod app build with Java. The app constist of 10 fixed questions and it lists these in to a quiz. it has a progress bar which can show the progress of the quiz and users get the score after the quiz in an alert box"
          learned={[
            "Various new components in android",
            "Constrained layout",
            "logic of quiz app",
          ]}
          githubLink="https://github.com/Royal-lobster/quizapp-android"
        />
        {/* Dice app */}
        <Project
          title="Dice App"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/diceapp-android/master/Screenshot.png"
          about="Users can press roll dice button to randomly get two dice results while playing board games."
          learned={[
            "using Assets in Android Project",
            "using savedInstanceState",
            "click listener",
            "java Basics",
            "introduction to Android studio",
          ]}
          githubLink="https://github.com/Royal-lobster/diceapp-android"
        />
        {/* Pig game */}
        <Project
          title="Pig game"
          imgurl="https://raw.githubusercontent.com/Royal-lobster/piggame-javascript/master/Screenshot.png"
          about="Pig Game is a simple 2 player dice game. This game is made by HTML, CSS and JS"
          learned={[
            "Randomizing results",
            "DOM Manipulation",
            "Application State",
          ]}
          githubLink="https://github.com/Royal-lobster/piggame-javascript"
          projectLink="https://dice-gamejs.netlify.app/"
        />
        {/* exammaterials.in*/}
        <Project
          title="Exammaterials.in"
          imgurl= {Exammaterials}
          about="A Education site where students get various study materials for free with clean interface with out ads"
          learned={[
            "Wordpress",
            "Wordpress Speed Optimization",
            "using Google analytics",
            "Sending news letter form Mailchimp",
            "Cloudflare",
            "Using Cpanel",
            "Setting Domain names",
          ]}
          projectLink="https://exammaterials.in/"
        />
      </div>
      <p className="p-3 m-8 border-2 rounded-full text-center">
        For more Projects please Checkout my{" "}
        <a
          href="https://github.com/Royal-lobster"
          style={{ color: "var(--primary-color)" }}
        >
          Github
        </a>
      </p>
    </div>
  );
}

export default Projects;
